/* tslint:disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpRequest, HttpResponse, HttpHeaders } from '@angular/common/http';
import { BaseService as __BaseService } from '../base-service';
import { ApiConfiguration as __Configuration } from '../api-configuration';
import { StrictHttpResponse as __StrictHttpResponse } from '../strict-http-response';
import { Observable as __Observable } from 'rxjs';
import { map as __map, filter as __filter } from 'rxjs/operators';

import { FitTestDocumentModel } from '../models/fit-test-document-model';
import { FindFilter } from '../models/find-filter';
import { LookupValueModel } from '../models/lookup-value-model';
@Injectable({
  providedIn: 'root',
})
class FitTestDocumentService extends __BaseService {
  static readonly DownloadFilePath = '/api/hir/FitTestDocument/DownloadFile';
  static readonly EditFilePath = '/api/hir/FitTestDocument/EditFile';
  static readonly GetDocumentsForFITtestsPath = '/api/hir/FitTestDocument/GetDocumentsForFITtests';
  static readonly GetAllDomainPath = '/api/hir/FitTestDocument/AllDomain';
  static readonly FindInDomainPath = '/api/hir/FitTestDocument/FindInDomain';
  static readonly LookupsPath = '/api/hir/FitTestDocument/Lookups';
  static readonly DistinctStringLookupsPath = '/api/hir/FitTestDocument/DistinctStringLookups';
  static readonly UpdatePath = '/api/hir/FitTestDocument';
  static readonly AddPath = '/api/hir/FitTestDocument';
  static readonly DeletePath = '/api/hir/FitTestDocument';

  constructor(
    config: __Configuration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * @param id undefined
   */
  DownloadFileResponse(id: number): __Observable<__StrictHttpResponse<null>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/api/hir/FitTestDocument/DownloadFile/${id}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<null>;
      })
    );
  }
  /**
   * @param id undefined
   */
  DownloadFile(id: number): __Observable<null> {
    return this.DownloadFileResponse(id).pipe(
      __map(_r => _r.body as null)
    );
  }

  exportData(file) {
    const url = (file) ? `${this.rootUrl}${FitTestDocumentService.DownloadFilePath}/${file.id}` : `${this.rootUrl}${FitTestDocumentService.DownloadFilePath}`;
    return this.http.get(url, { responseType: 'blob', observe: 'response' });
  }

  /**
   * @param params The `FitTestDocumentService.EditFileParams` containing the following parameters:
   *
   * - `ResponderId`:
   *
   * - `FormFile`:
   *
   * - `FitTestId`:
   *
   * - `DocumentId`:
   *
   * - `Comment`:
   */
  EditFileResponse(params: FitTestDocumentService.EditFileParams): __Observable<__StrictHttpResponse<null>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __headers.append('Content-Type', 'multipart/form-data');
    let __formData = new FormData();
    __body = __formData;
   if(params.ResponderId !== null && typeof params.ResponderId !== "undefined") { __formData.append('ResponderId', JSON.stringify(params.ResponderId));}
   if(params.FormFile !== null && typeof params.FormFile !== "undefined") { __formData.append('FormFile', params.FormFile as string | Blob);}
   if(params.FitTestId !== null && typeof params.FitTestId !== "undefined") { __formData.append('FitTestId', JSON.stringify(params.FitTestId));}
   if(params.DocumentId !== null && typeof params.DocumentId !== "undefined") { __formData.append('DocumentId', JSON.stringify(params.DocumentId));}
   if(params.Comment !== null && typeof params.Comment !== "undefined") { __formData.append('Comment', params.Comment as string | Blob);}
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/api/hir/FitTestDocument/EditFile`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<null>;
      })
    );
  }
  /**
   * @param params The `FitTestDocumentService.EditFileParams` containing the following parameters:
   *
   * - `ResponderId`:
   *
   * - `FormFile`:
   *
   * - `FitTestId`:
   *
   * - `DocumentId`:
   *
   * - `Comment`:
   */
  EditFile(params: FitTestDocumentService.EditFileParams): __Observable<null> {
    return this.EditFileResponse(params).pipe(
      __map(_r => _r.body as null)
    );
  }

  /**
   * @param fittestIds undefined
   * @return Success
   */
  GetDocumentsForFITtestsResponse(fittestIds?: Array<number>): __Observable<__StrictHttpResponse<Array<FitTestDocumentModel>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    (fittestIds || []).forEach(val => {if (val != null) __params = __params.append('fittestIds', val.toString())});
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/api/hir/FitTestDocument/GetDocumentsForFITtests`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<FitTestDocumentModel>>;
      })
    );
  }
  /**
   * @param fittestIds undefined
   * @return Success
   */
  GetDocumentsForFITtests(fittestIds?: Array<number>): __Observable<Array<FitTestDocumentModel>> {
    return this.GetDocumentsForFITtestsResponse(fittestIds).pipe(
      __map(_r => _r.body as Array<FitTestDocumentModel>)
    );
  }

  /**
   * @return Success
   */
  GetAllDomainResponse(): __Observable<__StrictHttpResponse<Array<FitTestDocumentModel>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/api/hir/FitTestDocument/AllDomain`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<FitTestDocumentModel>>;
      })
    );
  }
  /**
   * @return Success
   */
  GetAllDomain(): __Observable<Array<FitTestDocumentModel>> {
    return this.GetAllDomainResponse().pipe(
      __map(_r => _r.body as Array<FitTestDocumentModel>)
    );
  }

  /**
   * @param findFilter undefined
   * @return Success
   */
  FindInDomainResponse(findFilter?: FindFilter): __Observable<__StrictHttpResponse<Array<FitTestDocumentModel>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = findFilter;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/api/hir/FitTestDocument/FindInDomain`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<FitTestDocumentModel>>;
      })
    );
  }
  /**
   * @param findFilter undefined
   * @return Success
   */
  FindInDomain(findFilter?: FindFilter): __Observable<Array<FitTestDocumentModel>> {
    return this.FindInDomainResponse(findFilter).pipe(
      __map(_r => _r.body as Array<FitTestDocumentModel>)
    );
  }

  /**
   * @return Success
   */
  LookupsResponse(): __Observable<__StrictHttpResponse<{[key: string]: Array<LookupValueModel>}>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/api/hir/FitTestDocument/Lookups`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<{[key: string]: Array<LookupValueModel>}>;
      })
    );
  }
  /**
   * @return Success
   */
  Lookups(): __Observable<{[key: string]: Array<LookupValueModel>}> {
    return this.LookupsResponse().pipe(
      __map(_r => _r.body as {[key: string]: Array<LookupValueModel>})
    );
  }

  /**
   * @return Success
   */
  DistinctStringLookupsResponse(): __Observable<__StrictHttpResponse<{[key: string]: Array<string>}>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/api/hir/FitTestDocument/DistinctStringLookups`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<{[key: string]: Array<string>}>;
      })
    );
  }
  /**
   * @return Success
   */
  DistinctStringLookups(): __Observable<{[key: string]: Array<string>}> {
    return this.DistinctStringLookupsResponse().pipe(
      __map(_r => _r.body as {[key: string]: Array<string>})
    );
  }

  /**
   * @param obj undefined
   * @return Success
   */
  UpdateResponse(obj?: FitTestDocumentModel): __Observable<__StrictHttpResponse<FitTestDocumentModel>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = obj;
    let req = new HttpRequest<any>(
      'PUT',
      this.rootUrl + `/api/hir/FitTestDocument`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<FitTestDocumentModel>;
      })
    );
  }
  /**
   * @param obj undefined
   * @return Success
   */
  Update(obj?: FitTestDocumentModel): __Observable<FitTestDocumentModel> {
    return this.UpdateResponse(obj).pipe(
      __map(_r => _r.body as FitTestDocumentModel)
    );
  }

  /**
   * @param obj undefined
   * @return Success
   */
  AddResponse(obj?: FitTestDocumentModel): __Observable<__StrictHttpResponse<FitTestDocumentModel>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = obj;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/api/hir/FitTestDocument`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<FitTestDocumentModel>;
      })
    );
  }
  /**
   * @param obj undefined
   * @return Success
   */
  Add(obj?: FitTestDocumentModel): __Observable<FitTestDocumentModel> {
    return this.AddResponse(obj).pipe(
      __map(_r => _r.body as FitTestDocumentModel)
    );
  }

  /**
   * @param obj undefined
   * @return Success
   */
  DeleteResponse(obj?: FitTestDocumentModel): __Observable<__StrictHttpResponse<FitTestDocumentModel>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = obj;
    let req = new HttpRequest<any>(
      'DELETE',
      this.rootUrl + `/api/hir/FitTestDocument`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<FitTestDocumentModel>;
      })
    );
  }
  /**
   * @param obj undefined
   * @return Success
   */
  Delete(obj?: FitTestDocumentModel): __Observable<FitTestDocumentModel> {
    return this.DeleteResponse(obj).pipe(
      __map(_r => _r.body as FitTestDocumentModel)
    );
  }
}

module FitTestDocumentService {

  /**
   * Parameters for EditFile
   */
  export interface EditFileParams {
    ResponderId?: number;
    FormFile?: Blob;
    FitTestId?: number;
    DocumentId?: number;
    Comment?: string;
  }
}

export { FitTestDocumentService }
